import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import Prismic from 'prismic-javascript';
import PrismicConfig from './prismic-configuration';
import './App.scss';
import NotFound from './NotFound';
import About from './Pages/About/About';
import Footer from './Components/Footer/Footer';
import Header from './Components/Header/Header';
import Home from './Pages/Home/Home';
import PreRelease from './Pages/PreRelease/PreRelease';
import Project from './Pages/Project/Project';
import Projects from './Pages/Projects/Projects';
// import Preview from './Preview';
// import Page from './Pages/Page/Page';

// const App = (props) => (
//   <React.Fragment>
//     <Header />
//     <main>
//       <Router>
//           <Switch>
//             <Redirect exact from="/home" to="/"/>
//             <Route exact path="/" component={Home} />
//             <Route exact path="/about" render={routeProps => <About {...routeProps} prismicCtx={props.prismicCtx} />} />
//             <Route exact path="/projects" render={routeProps => <Projects {...routeProps} prismicCtx={props.prismicCtx} />} />
//             <Route exact path="/project/:uid" render={routeProps => <Project {...routeProps} prismicCtx={props.prismicCtx} />} />
//             {/* <Route exact path="/preview" render={routeProps => <Preview {...routeProps} prismicCtx={props.prismicCtx} />} /> */}
//             {/* <Route exact path="/:uid" render={routeProps => <Page {...routeProps} prismicCtx={props.prismicCtx} />} /> */}
//             <Route component={NotFound} />
//           </Switch>
//       </Router>
//     </main>
//     <Footer />
//   </React.Fragment>
// );

// export default App;

export default class App extends React.Component{

  state = {
    doc: null,
    notFound: false,
  }

  componentWillMount(){
    Prismic.api(PrismicConfig.apiEndpoint).then(api => {
        api.query(
            Prismic.Predicates.at('document.type', 'settings'),
        ).then(response => {
            if(response.results.length > 0){
                this.setState({ doc: response.results });
            } else{
                this.setState({ notFound: true });
            }
        });
    });
  }

  componentDidUpdate(){
    this.setPreReleaseVersion()
  }

  setPreReleaseVersion(){
    if(this.state.doc){
        const {isprerelease} = this.state.doc[0].data
        const bodyElement = document.querySelector('body')

        if(bodyElement && isprerelease === 'yes'){
            bodyElement.classList.add('prerelease')
        }
    }
  }

  render(){
    if (this.state.doc) {
      const {isprerelease} = this.state.doc[0].data

      if(isprerelease){
        return(
          <React.Fragment>
          <main>
            <Router>
                <Switch>
                  <Redirect exact from="/prerelease" to="/"/>
                  <Route exact path="/" component={PreRelease} />
                  <Route component={NotFound} />
                </Switch>
            </Router>
          </main>
          <Footer />
        </React.Fragment>
        )
      } else {
          return(
            <React.Fragment>
            <Header />
            <main>
              <Router>
                  <Switch>
                    <Redirect exact from="/home" to="/"/>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/about" render={routeProps => <About {...routeProps} prismicCtx={this.props.prismicCtx} />} />
                    <Route exact path="/projects" render={routeProps => <Projects {...routeProps} prismicCtx={this.props.prismicCtx} />} />
                    <Route exact path="/project/:uid" render={routeProps => <Project {...routeProps} prismicCtx={this.props.prismicCtx} />} />
                    {/* <Route exact path="/preview" render={routeProps => <Preview {...routeProps} prismicCtx={props.prismicCtx} />} /> */}
                    {/* <Route exact path="/:uid" render={routeProps => <Page {...routeProps} prismicCtx={props.prismicCtx} />} /> */}
                    <Route component={NotFound} />
                  </Switch>
              </Router>
            </main>
            <Footer />
          </React.Fragment>
          )

      }
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <h1>Loading</h1>;
    
  }
}



// WEBPACK FOOTER //
// ./src/App.js